import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f8f74d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "v2-con" }, "Full", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "xui" }, "UI", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "switch-con",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.gotoV1 && _ctx.gotoV1(...args)))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["v1-con", { 'text-black': _ctx.isNftPage }])
      }, "Lite", 2),
      _hoisted_1
    ]),
    _hoisted_2
  ], 64))
}